import { CountUp } from 'countup.js';

const digits = document.querySelectorAll('.digits');



if (digits.length) {
  const observerOptions = {
    root: null, // relative to the viewport
    rootMargin: '0px',
    threshold: 0.1 // trigger when 10% of the element is in view
  };

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const numeral = entry.target;
        const min = numeral.getAttribute('data-countMin');
        const max = numeral.getAttribute('data-countMax');
        const duration = numeral.getAttribute('data-duration');
        const val = numeral.innerHTML;
        const sufix = numeral.getAttribute('data-sufix');

        const countUp = new CountUp(numeral, max, {
          startVal: min,
          duration: +duration,
          separator: '.',
          onCompleteCallback: () => {
            numeral.innerHTML = sufix ? val + sufix : val;
          }
        });

        countUp.start();
        observer.unobserve(numeral); // stop observing once animation has started
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  digits.forEach(numeral => {
    observer.observe(numeral);
  });
}
